import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';

const style = require('./SupplierQuotesPage.less');

export default class SupplierQuotesPage extends React.Component<any, null> {
	constructor(props) {
		super(props);
	}

	render() {
		const { match } = this.props;
		const path = nullSafeGetOrElse('path', match, '/supplier/quotes');
		return (
			<AccessPermissionChecker name={PERMISSION_NAMES.CAN_VIEW_QUOTES} isPage>
				<div>
					<Route
						path={`${path}`}
						exact={true}
						render={(props) => (
							<Redirect
								to={{
									pathname: `${path}/overview`,
								}}
							/>
						)}
					/>
					{this.props.childRoutes.map((r, i) => (
						<RouteWithSubRoutes key={i} {...r} />
					))}
				</div>
			</AccessPermissionChecker>
		);
	}
}
